// Lightweight referral plumbing for the "Founding Riders" system.
// We never surface this as a referral program to the visitor — it's purely
// recognition data tracked in the background for the admin dashboard.

const REF_INCOMING = "roadrig.ref.incoming";   // ?ref=VIP-XXXX picked up from URL
const REF_MY_NUMBER = "roadrig.vip.number";    // the visitor's own member number once they sign up

/** Capture ?ref=VIP-XXXX from the current URL and persist it in localStorage. */
export const captureIncomingReferral = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("ref");
    if (!raw) return null;
    const normalised = raw.trim().toUpperCase();
    if (!/^VIP-?\d{1,6}$/.test(normalised)) return null;
    localStorage.setItem(REF_INCOMING, normalised);
    return normalised;
  } catch {
    return null;
  }
};

/** Returns the stored incoming referral code (the VIP who shared the link with us). */
export const getIncomingReferral = () => {
  try { return localStorage.getItem(REF_INCOMING) || null; } catch { return null; }
};

/** Persist the visitor's OWN VIP member number after they sign up. */
export const setMyMemberNumber = (n) => {
  if (!n || typeof n !== "number") return;
  try { localStorage.setItem(REF_MY_NUMBER, String(n)); } catch { /* noop */ }
};

/** Returns the stored VIP member number for the current visitor (if signed up). */
export const getMyMemberNumber = () => {
  try {
    const v = localStorage.getItem(REF_MY_NUMBER);
    if (!v) return null;
    const n = parseInt(v, 10);
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch { return null; }
};

export const formatVipCode = (n) => `VIP-${String(n).padStart(4, "0")}`;

/** Build a shareable URL for the current page, attaching the visitor's own
 *  VIP code so any signup they generate is attributed back to them. */
export const buildShareUrl = (baseUrl) => {
  try {
    const url = new URL(baseUrl || window.location.href);
    url.searchParams.delete("ref");
    const me = getMyMemberNumber();
    if (me) url.searchParams.set("ref", formatVipCode(me));
    return url.toString();
  } catch {
    return baseUrl || (typeof window !== "undefined" ? window.location.href : "");
  }
};
